import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import Header from './Header'
import Charts from './Charts'
import MetricsTable from 'Components/Backtest/tables/Metrics'
import TransactionsTable from 'Components/Backtest/tables/Transactions'

@inject('store') @observer
class Total extends Component {
  render() {
    const {id} = this.props
    const {backtest} = this.props.store
    const {selected} = backtest.tables
    return(
      <div className='card'>
        <Header id={id}/>
        <div>
          {selected === 'metrics' && <MetricsTable id={id}/>}
          {selected === 'transactions' && <TransactionsTable id={id}/>}
        </div>
        <Charts id={id} loading={backtest.single.loading}/>
      </div>
    )
  }
}

export default Total
